import { LocalizationModel, LocalizationService, LocalizationServiceAdapter } from "@bender/localization";
import { env } from "../auth/config/env";
export class BenderLocalizationLoader {
    async loadLocalizations() {
        var _a;
        const prefLanguage = (_a = localStorage.getItem("benderPreferredLanguage")) !== null && _a !== void 0 ? _a : navigator.language;
        const language = prefLanguage === "en-US" || prefLanguage === "pt-BR" || prefLanguage === "pt-PT" || prefLanguage === "zh-Hans"
            ? prefLanguage.toLowerCase()
            : prefLanguage.split("-")[0];
        let response = await fetch(`${env.webComponentsContainerEndpoint}/bundles/v2/languages/export-default/allTexts_${language}_filled.json`);
        if (response.status === 404) {
            response = await fetch(`${env.webComponentsContainerEndpoint}/bundles/v2/languages/export-default/allTexts_en_filled.json`);
        }
        const data = await response.json();
        const translations = data.data;
        return new LocalizationServiceAdapter(new LocalizationService(new LocalizationModel("language", translations)));
    }
}
//# sourceMappingURL=bender-translations.js.map